//import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "./master.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { store, persistor } from "./ReduxStore/store";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
//import { msalConfig } from "./authConfig";
import { AuthProvider } from "react-oidc-context";
import { ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
//import { lightTheme } from "./Pages/Components/CommonComponents/common_components";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
//const msalInstance = new PublicClientApplication(msalConfig);
ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
           
              <AuthProvider>
               
                  <CssBaseline />
                  <App />
                
              </AuthProvider>
           
          </PersistGate>
        </Provider>,
    </BrowserRouter>,
    rootElement);

   
      
registerServiceWorker();



//import React from 'react';
//import ReactDOM from 'react-dom';
//import './index.css';
//import App from './App';
//import reportWebVitals from './reportWebVitals';

//ReactDOM.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>,
//  document.getElementById('root')
//);

//// If you want to start measuring performance in your app, pass a function
//// to log results (for example: reportWebVitals(console.log))
//// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
